module.exports = __webpack_public_path__ + "img/2025-fusion-rolando.00da21d.jpg";